import React from "react";
import "./news.scss";

const rows = [
  {
    id: 1,
    issue: "Jun 2026 (Early)",
    project: "Kuching Central Mall Extension",
    state: "Sarawak",
    category: "Commercial",
    stage: "Construction",
    value: "RM120M",
    developer: "ABC Development Sdn Bhd",
    consultant: "XYZ Architect",
    contractor: "DEF Builder",
    start: "2026-07-01",
    imported: "2026-06-23 09:15",
    leadScore: 85,
    aiScore: 92,
    status: "New",
    assignedTo: "Unassigned",
    source: "MyBina",
  },
  {
    id: 2,
    issue: "Jun 2026 (Early)",
    project: "Miri Industrial Park Phase 3",
    state: "Sarawak",
    category: "Industrial",
    stage: "Tender",
    value: "RM80M",
    developer: "Miri Holdings",
    consultant: "KTA Architect",
    contractor: "-",
    start: "-",
    imported: "2026-06-23 09:20",
    leadScore: 71,
    aiScore: 84,
    status: "Approved",
    assignedTo: "Alex Tan",
    source: "MyBina",
  },
  {
    id: 3,
    issue: "Jun 2026 (Early)",
    project: "Samarahan Boulevard Development",
    state: "Sarawak",
    category: "Infrastructure",
    stage: "Planning",
    value: "RM250M",
    developer: "Sarawak Metro Development",
    consultant: "Urbanline Consultant",
    contractor: "-",
    start: "2027-01-15",
    imported: "2026-06-23 09:28",
    leadScore: 79,
    aiScore: 88,
    status: "New",
    assignedTo: "Unassigned",
    source: "DayakDaily",
  },
  {
    id: 4,
    issue: "Jun 2026 (Mid)",
    project: "Bintulu Mixed Development Hub",
    state: "Sarawak",
    category: "Mixed Development",
    stage: "Design",
    value: "RM310M",
    developer: "Bintulu Landmark Group",
    consultant: "Nexus Design Studio",
    contractor: "-",
    start: "2026-11-01",
    imported: "2026-06-23 10:05",
    leadScore: 82,
    aiScore: 90,
    status: "Assigned",
    assignedTo: "Michelle Wong",
    source: "MyBina",
  },
  {
    id: 5,
    issue: "Jun 2026 (Mid)",
    project: "Sibu Private Medical Centre",
    state: "Sarawak",
    category: "Healthcare",
    stage: "Tender",
    value: "RM95M",
    developer: "CareBuild Healthcare",
    consultant: "MedArch Planner",
    contractor: "Pending Award",
    start: "2026-09-10",
    imported: "2026-06-23 10:16",
    leadScore: 76,
    aiScore: 81,
    status: "New",
    assignedTo: "Unassigned",
    source: "MyBina",
  },
  {
    id: 6,
    issue: "Jun 2026 (Late)",
    project: "Kota Samarahan Apartment Blocks",
    state: "Sarawak",
    category: "Residential",
    stage: "Construction",
    value: "RM68M",
    developer: "Premier Homes Sdn Bhd",
    consultant: "HomePlan Architect",
    contractor: "SolidBuild Construction",
    start: "2026-08-01",
    imported: "2026-06-23 10:31",
    leadScore: 66,
    aiScore: 74,
    status: "Contacted",
    assignedTo: "Jason Lee",
    source: "MyBina",
  },
  {
    id: 7,
    issue: "Jun 2026 (Late)",
    project: "Kuching Warehouse & Logistics Centre",
    state: "Sarawak",
    category: "Industrial",
    stage: "Construction",
    value: "RM42M",
    developer: "East Logistics Park",
    consultant: "Industrial Design Associates",
    contractor: "Mega Structure Works",
    start: "2026-06-30",
    imported: "2026-06-23 10:48",
    leadScore: 73,
    aiScore: 79,
    status: "Approved",
    assignedTo: "Alex Tan",
    source: "CIDB",
  },
  {
    id: 8,
    issue: "Jul 2026 (Early)",
    project: "Mukah Education Campus Upgrade",
    state: "Sarawak",
    category: "Education",
    stage: "Planning",
    value: "RM55M",
    developer: "Education Facilities Board",
    consultant: "Campus Design Consultant",
    contractor: "-",
    start: "2027-02-01",
    imported: "2026-06-23 11:02",
    leadScore: 61,
    aiScore: 68,
    status: "New",
    assignedTo: "Unassigned",
    source: "Tender Portal",
  },
];

const getScoreClass = (score) => {
  if (score >= 80) return "score score--high";
  if (score >= 60) return "score score--medium";
  return "score score--low";
};

const getStatusClass = (status) => `status status--${status.toLowerCase().replace(/\s+/g, "-")}`;

export default function NewsPage() {
  return (
    <div className="news-page">
      <div className="news-page__topbar">
        <div>
          <h2>Construction News & Opportunities</h2>
          <p>Review imported projects, approve useful records, and convert them into leads.</p>
        </div>
        <button className="create-button">+ Create News</button>
      </div>

      <div className="news-page__filters">
        <input placeholder="Search project, developer, consultant..." />
        <select><option>All Issues</option><option>Jun 2026 Early</option><option>Jun 2026 Mid</option><option>Jun 2026 Late</option></select>
        <select><option>All States</option><option>Sarawak</option><option>Sabah</option><option>Selangor</option></select>
        <select><option>All Categories</option><option>Commercial</option><option>Industrial</option><option>Residential</option><option>Infrastructure</option></select>
        <select><option>All Stages</option><option>Planning</option><option>Design</option><option>Tender</option><option>Construction</option></select>
      </div>

      <div className="news-page__table-wrapper">
        <table className="news-page__table">
          <thead>
            <tr>
              <th className="sticky-col">Actions</th>
              <th>Project / Opportunity</th>
              <th>AI Score</th>
              <th>Status</th>
              <th>Stage</th>
              <th>Project Value</th>
              <th>State</th>
              <th>Developer</th>
              <th>Issue</th>
              <th>Main Consultant</th>
              <th>Main Contractor</th>
              <th>Construction Start</th>
              <th>Lead Score</th>
              <th>Assigned To</th>
              <th>Source</th>
              <th>Last Imported</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, index) => (
              <React.Fragment key={row.id}>
                <tr className={`record-row record-row--main record-row--${index % 2 === 0 ? "even" : "odd"}`}>
                  <td className="sticky-col actions-cell" rowSpan={2}>
                    <div className="action-buttons" aria-label={`Actions for ${row.project}`}>
                      <button type="button" className="icon-button" title="View" aria-label="View">👁</button>
                      <button type="button" className="icon-button" title="Edit" aria-label="Edit">✎</button>
                      <button type="button" className="icon-button icon-button--approve" title="Approve" aria-label="Approve">✓</button>
                      <button type="button" className="icon-button icon-button--archive" title="Archive" aria-label="Archive">⌂</button>
                    </div>
                  </td>
                  <td className="project-cell">
                    <strong>{row.project}</strong>
                    <span>{row.category}</span>
                  </td>
                  <td><span className={getScoreClass(row.aiScore)}>{row.aiScore}</span></td>
                  <td><span className={getStatusClass(row.status)}>{row.status}</span></td>
                  <td>{row.stage}</td>
                  <td><strong>{row.value}</strong></td>
                  <td>{row.state}</td>
                  <td>{row.developer}</td>
                  <td>{row.issue}</td>
                  <td>{row.consultant}</td>
                  <td>{row.contractor}</td>
                  <td>{row.start}</td>
                  <td>{row.leadScore}</td>
                  <td>{row.assignedTo}</td>
                  <td>{row.source}</td>
                  <td>{row.imported}</td>
                </tr>
                <tr className={`record-row record-row--detail record-row--${index % 2 === 0 ? "even" : "odd"}`}>
                  <td colSpan="15">
                    <div className="detail-grid">
                      <div><label>Issue</label><strong>{row.issue}</strong></div>
                      <div><label>Consultant</label><strong>{row.consultant}</strong></div>
                      <div><label>Contractor</label><strong>{row.contractor}</strong></div>
                      <div><label>Construction Start</label><strong>{row.start}</strong></div>
                      <div><label>Lead Score</label><strong>{row.leadScore}</strong></div>
                      <div><label>Assigned To</label><strong>{row.assignedTo}</strong></div>
                      <div><label>Source</label><strong>{row.source}</strong></div>
                      <div><label>Last Imported</label><strong>{row.imported}</strong></div>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
